var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderSalePurchase',{attrs:{"img_header":_vm.header_image,"header":"สร้างใบสั่งซื้อ (Create purchase order)","link_back":"salemain/wholesalesalepurchaseorder"}}),_c('Add_purchaseorder_wholesale_vip')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }